var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnhanceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#101010",
    d: "m23.043 4.65l-.404-2.313l-1.59 1.727l-2.324-.33l1.15 2.045l-1.03 2.107l2.3-.463l1.687 1.633l.27-2.332l2.075-1.1l-2.135-.976zm3.174 13.548l-.182-1.25l-.882.905l-1.245-.214l.588 1.117l-.588 1.118l1.245-.214l.882.906l.182-1.25l1.133-.56zM4.92 7.672l.948-.372l.844.57l-.062-1.017l.802-.627l-.985-.256l-.35-.957l-.546.86l-1.017.035l.647.786l-.28.978zm5.52 2.833l1.02-1.096l1.48.218l-.726-1.31l.667-1.34l-1.47.286l-1.068-1.048l-.182 1.487l-1.328.693l1.358.632l.25 1.477zm6.794 2.216c-.588-.367-1.172-.617-1.692-.728c-.492-.09-1.04-.15-1.425.374L2.562 30.788h6.68l9.67-15.416c.302-.576.01-1.04-.284-1.447c-.325-.417-.806-.835-1.394-1.204m-3.62 9.216c-.255-.396-.74-.857-1.374-1.254c-.632-.396-1.258-.634-1.726-.69l4.42-7.052c.065-.013.263-.02.544.066c.346.092.785.285 1.225.562c.504.313.908.677 1.133.97a1.1 1.1 0 0 1 .2.35z",
    strokeWidth: 1,
    stroke: "#101010"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnhanceIcon);
export default __webpack_public_path__ + "static/media/enhance_icon.d21183edc465eb2477fd16b7a2a760f8.svg";
export { ForwardRef as ReactComponent };